import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
const style = {flexGrow:1, display:'flex', justifyContent:'center', alignItems:'center'};
export const Loading = () => <div style={style}><CircularProgress /></div>
export default Loading;